import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'ui-list',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ui-list.component.html',
  styleUrl: './ui-list.component.scss'
})
export class UiListComponent {
  /**
   * Visual variant of the list
   */
  @Input() variant: 'default' | 'bordered' | 'zebra' = 'default';

  /**
   * Compact/normal spacing
   */
  @Input() compact = false;

  /**
   * Enable hover effect on items
   */
  @Input() hoverable = true;

  /**
   * Render a bordered, rounded container (DaisyUI-ish)
   */
  @Input() boxed = true;

  get computedClasses(): string {
    const classes: string[] = ['w-full'];

    if (this.boxed) {
      classes.push('rounded-box', 'border', 'border-base-300', 'bg-base-100');
    }

    if (this.variant === 'bordered') {
      classes.push('divide-y', 'divide-base-300');
    }

    if (this.variant === 'zebra') {
      classes.push('[&>*:nth-child(even)]:bg-base-200/40');
    }

    // These are picked up by UiListItem (keeps API stable)
    if (this.compact) {
      classes.push('ui-list--compact');
    }

    if (this.hoverable) {
      classes.push('ui-list--hoverable');
    }

    return classes.join(' ');
  }
}
